import { useContext, createContext } from "react";

export const AppContext = createContext(null);

//Permite usar variables de contexto en común para todos los componentes para isAutenticated
export function useAppContext() {
  return useContext(AppContext);
}
